export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'panelforge.theme';

function isTheme(value: unknown): value is Theme {
  return value === 'light' || value === 'dark';
}

export function getTheme(): Theme {
  if (typeof window === 'undefined') return 'light';

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isTheme(stored) ? stored : 'light';
  } catch {
    return 'light';
  }
}

export function setTheme(theme: Theme): void {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = theme;
  }

  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Storage may be unavailable in private mode or restricted embeds.
  }
}
